<template>
  <!-- 报名须知 -->
  <div id="bmShouldKnow">
    <div class="notice_word">
      <div class="notice_top">
        <p>{{ dialogdata.name }}</p>
        <span class="closeNotice" @click="closeNotice" v-if="showClose">x</span>
      </div>
      <div class="notice_content customScrollBar">
        <!-- 具体通知内容 -->
        <pdf
          v-for="item in numPages"
          :key="item"
          :src="dialogdata.path"
          :page="item"
          ref="pdf"
        ></pdf>
      </div>
      <div class="fenshu" v-if="dialogdata.scoreUpload" @click="scoreupload">
        查分申请表附件下载
      </div>
      <div
        class="notice_bottom1"
        v-if="showClose"
        @click="clickCloseTerrace(dialogdata.entrance)"
      >
        确定
      </div>
      <div class="notice_bottom2" v-else>确定{{ timeCont }}秒</div>
    </div>
  </div>
</template>

<script>
import pdf from "vue-pdf";
export default {
  components: {
    pdf,
  },
  name: "bmShouldKnow",
  props: {
    bmShouldKnowData: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      dialogdata: this.bmShouldKnowData,
      numPages: 0,
      pdfSrc: "http://192.168.0.119:6654/123.pdf",
      showClose: false,
      timeCont: "5", //报名须知时间,关闭倒计时
      ScorePath: "", //查分申请表下载地址
    };
  },
  methods: {
    closeNotice() {
      this.$emit("closeNotice", false);
    },
    getNumPages() {
      let loadingTask = pdf.createLoadingTask(this.dialogdata.path);
      loadingTask.promise
        .then((pdf) => {
          this.numPages = pdf.numPages;
          this.countDown(this.timeCont); //关闭报名须知倒计时
        })
        .catch((err) => {
          console.error("pdf 加载失败", err);
        });
    },
    countDown(time) {
      let _this = this;
      time--;
      if (time == 0) {
        _this.timeCont = "";
        this.showClose = true;
        return;
      }
      let timer = setTimeout(function () {
        _this.timeCont = time;
        _this.countDown(time);
      }, 1000);
    },
    clickCloseTerrace(url) {
      console.log("llss", this.dialogdata);
      this.$emit("clickCloseTerrace", false);
    },
    //查看查分申请表
    getScorePath() {
      this.$request("post", "/getScorePath", null, (data) => {
        this.ScorePath = data.path;
      });
    },
    //查看查分申请表附件下载
    scoreupload() {
      window.open(this.ScorePath);
    },
  },
  mounted() {
    setTimeout(() => {
      this.getNumPages();
    }, 0);
    this.getScorePath();
  },
};
</script>

<style lang="less" scoped>
#bmShouldKnow {
  position: absolute;
  z-index: 999;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;

  .notice_word {
    width: 80%;
    max-width: 900px;
    height: 90%;
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 10px;
    box-sizing: border-box;
    padding: 35px;
    .notice_top {
      width: 100%;
      height: 50px;
      display: flex;
      justify-content: center;
      align-items: flex-end;
      position: relative;
      > p {
        font-size: 20px;
        font-weight: 700;
        letter-spacing: 3px;
      }
      .closeNotice {
        position: absolute;
        top: -20px;
        right: 0;
        font-size: 30px;
        &:hover {
          cursor: pointer;
          color: red;
        }
      }
    }
    .notice_content {
      width: 100%;
      height: 800px;
      display: flex;
      overflow-y: auto;
      box-sizing: border-box;
      margin-top: 50px;
      > .p {
        text-align: left;
        text-indent: 2em;
      }
      /deep/ img {
        width: 94% !important;
        height: auto !important;
      }
    }
    .fenshu {
      width: 100%;
      height: 20px;
      font-size: 15px;
      color: red;
      &:hover {
        cursor: pointer;
      }
    }

    .notice_bottom1 {
      width: 50%;
      height: 50px;
      background: rgba(0, 79, 146, 1);
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 20px;
      color: #fff;
      letter-spacing: 5px;
      border-radius: 10px;
      cursor: pointer;
      margin-top: 10px;
    }
    .notice_bottom2 {
      width: 50%;
      height: 50px;
      background: rgba(0, 79, 146, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 20px;
      color: hsl(0, 0%, 100%);
      letter-spacing: 5px;
      border-radius: 10px;
    }
  }
  .customScrollBar {
    display: flex;
    flex-direction: column;
  }
}
</style>
